var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6745 11.1233C32.0318 9.85418 30.8001 9.10368 29.6753 9.90506L13.9731 21.0913C12.7532 21.9603 12.9451 23.6917 14.2613 23.6917H18.3961V23.6597H26.4547L19.8885 25.9766L16.9938 36.2602C16.6365 37.5294 17.868 38.2799 18.9929 37.4784L34.6952 26.2923C35.9151 25.4233 35.7231 23.6917 34.4069 23.6917H28.1366L31.6745 11.1233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3341 47.2211C37.3291 47.2211 47.8635 36.6867 47.8635 23.6917C47.8635 10.6968 37.3291 0.162354 24.3341 0.162354C11.3391 0.162354 0.804688 10.6968 0.804688 23.6917C0.804688 36.6867 11.3391 47.2211 24.3341 47.2211ZM29.6753 9.90506C30.8001 9.10368 32.0318 9.85418 31.6745 11.1233L28.1366 23.6917H34.4069C35.7231 23.6917 35.9151 25.4233 34.6952 26.2923L18.9929 37.4784C17.868 38.2799 16.6365 37.5294 16.9938 36.2602L19.8885 25.9766L26.4547 23.6597H18.3961V23.6917H14.2613C12.9451 23.6917 12.7532 21.9603 13.9731 21.0913L29.6753 9.90506Z",
    fill: "#2454FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb69ffa1cfbb691eef2a4cd319800487.svg";
export { ForwardRef as ReactComponent };